import axios from 'axios';

import { CUSTOMERS_FETCHED, FETCHING_CUSTOMERS, CUSTOMER_MANAGEMENT_LIST_FETCHED, FETCHING_CUSTOMER_MANAGEMENT_LIST } from '../actions';
import { API_URL } from '../utils/constant';


// Backs the customers MANAGEMENT page's paginated table only. Dispatches into
// state.customer.managementList/managementPagination — a separate slot from
// state.customer.list (the full roster fetchCustomersBasicList below feeds),
// so paging/searching this table can never truncate the shared roster that
// ClientSelector/campaigns Dashboard/SMTP Configure read from.
export const fetchCustomers = async (params = {}, dispatch) => {
	try {
		dispatch({
			type: FETCHING_CUSTOMER_MANAGEMENT_LIST,
			payload: null,
		});
		// auth is set globally by the axios request interceptor; params carries
		// { page, limit, search, sortField, sortOrder } for server-side paging.
		const response = await axios.get(`${API_URL}/customers`, { params });
		dispatch({
			type: CUSTOMER_MANAGEMENT_LIST_FETCHED,
			payload: response.data,
		});
	} catch (err) {
		if (err.response) {
			return dispatch({
				type: CUSTOMER_MANAGEMENT_LIST_FETCHED,
				payload: err.response.data,
			});
		}

		dispatch({
			type: CUSTOMER_MANAGEMENT_LIST_FETCHED,
			payload: { error: true, message: 'Something went wrong' },
		});
	}
};

export const fetchCustomersBasicList = async (token, dispatch) => {
	try {
		dispatch({
			type: FETCHING_CUSTOMERS,
			payload: null,
		});
		const response = await axios.get(`${API_URL}/customers_basic_list`, { headers: { Authorization: `Bearer ${token}` } });
		dispatch({
			type: CUSTOMERS_FETCHED,
			payload: response.data,
		});
	} catch (err) {
		if (err.response) {
			return dispatch({
				type: CUSTOMERS_FETCHED,
				payload: err.response.data,
			});
		}

		dispatch({
			type: CUSTOMERS_FETCHED,
			payload: { error: true, message: 'Something went wrong' },
		});
	}
}
